export const version = {
    name: `1.0.30`,
    code: 1030
}